<div class="topBar" id="topBar" data-automation-id="top-nav-bar-container">
    <div class="logo" data-automation-id="top-nav-bar-logo-icon"></div>
    <div *ngIf="!isHomeButtonHidden" class="home" [ngClass]="{'on-hover' : projectName, '' : !projectName}"
        (click)="homePage()" data-automation-id="top-nav-bar-home-button">
        <i class="fa fa-home fa-icon sizing-icons"></i>
        <span class="homeClass">Home</span>
    </div>
    <div class="project-name" *ngIf='projectName && !isProjectnameHidden'
        data-automation-id="top-nav-bar-project-container">
        <i class="fa fa-angle-right sizing-icons" [ngClass]="{'angle-icon-padding' : !hasMonitoringAccess}"></i>
        <div class="reef-review-menu">
            <li class="dropdown pulldown-section on-hover" dropdown>
                <div dropdownToggle role="button" class="reef-review-actions"
                    data-automation-id="top-nav-bar-reef-review-dropdown-button">
                    <i class="fa status-icon sizing-icons" [ngClass]="statusIconClasses"
                        (click)="openSystemStatus($event)" [title]="statusIconTooltip"
                        [attr.data-automation-id]="'top-nav-bar-' + statusIconAutoId"></i>
                    <span class="project" data-automation-id="top-nav-bar-project-name">{{ projectName }}
                        <span *ngIf='projectDescription' data-automation-id="top-nav-bar-project-description">-
                            {{ projectDescription }}</span>
                        <span class="reef-review-icons reef-review-icon-color"
                            (click)="openInReefReviewOrRelativityFromIcon($event)"
                            [title]="reviewSystemIconTitle"
                            *ngIf="isReefReviewProject || isRelativityProject">
                            <i class="fa fa-clone" [ngClass]="{'relativity-icon-color' : isRelativityProject }"></i>
                            <span [ngClass]="{'relativity-span-color' : isRelativityProject }">R</span>
                        </span>
                    </span>
                    <i class="fa fa-caret-down admin-caret"></i>
                </div>
                <ul *dropdownMenu class="dropdown-menu">
                    <li class="menu-item" data-automation-id="top-nav-bar-open-in-reef-review"
                        (click)="openInReefReviewOrRelativity()" *ngIf="isReefReviewProject || isRelativityProject"
                        [ngClass]="{'disabled' : !hasReviewProjectId }">
                        <div class="admin-icon reef-review-icons">
                            <i [ngClass]="{'relativity-icon-color' : isRelativityProject }" class="fa fa-clone"></i>
                            <span [ngClass]="{'relativity-icon-color' : isRelativityProject }">R</span>
                        </div>
                        <div class="admin-label">{{this.isReefReviewProject ? 'Open in Reef Review' : 'Open in Relativity Server'}}</div>
                        <div class="admin-icon external-link-icon" title="External link. Opens in a new tab or window.">
                            <i class="fa fa-external-link"></i>
                        </div>
                    </li>
                    <li class="menu-item" data-automation-id="top-nav-bar-reef-review-promotion-tracking"
                        (click)="openRRPromotionTracker()" *ngIf="isReefReviewProject || isRelativityProject"
                        [ngClass]="{'disabled' : !hasReviewProjectId }">
                        <div class="iconContainer">
                            <span class="fa-stack">
                                <i class="iconFirst fa-stack-1x fa fa-clone color-grey-08"></i>
                                <span class="r-reef-review-icon">R</span>
                                <i class="iconSecond fa-stack-1x fa fa-clock-o color-purple-03"></i>
                            </span>
                        </div>
                        <div class="admin-label">Review Promotion Tracking ...</div>
                        <div class="admin-icon external-link-icon" title="Opens in a new tab or window.">
                            <i class="fa fa-window-restore"></i>
                        </div>
                    </li>
                    <li class="divider" *ngIf="isReefReviewProject || isRelativityProject"></li>
                    <li class="menu-item" data-automation-id="top-nav-bar-audit-log" (click)="reefReviewViewAuditLog()">
                        <div class="iconContainer">
                            <span class="fa-stack">
                                <i class="iconFirst fa-stack-1x fa fa-history color-blue-grey-03"></i>
                                <i class="iconSecond fa-stack-1x fa fa-search color-blue-01"></i>
                            </span>
                        </div>
                        <div class="admin-label">Audit Log ...</div>
                    </li>
                    <li class="menu-item" data-automation-id="top-nav-bar-generate-billing-report"
                        (click)="reefReviewGenerateBillingReport()"
                        [title]="'Generate Billing Report (.xlsx) for download from the Work Basket'">
                        <div class="admin-icon">
                            <span class="fa-stack">
                                <i class="fa fa-download"></i>
                                <i class="fa fa-stack-1x fa fa-list-alt"></i>
                            </span>
                        </div>
                        <div class="admin-label">Generate Billing Report</div>
                    </li>
                    <li class="menu-item" data-automation-id="top-nav-bar-generate-source-tracking-report"
                        (click)="reefReviewGenerateSourceTrackingReport()"
                        [title]="'Generate Source Tracking Report (.xlsx) for download from the Work Basket'">
                        <div class="admin-icon">
                            <span class="fa-stack">
                                <i class="fa fa-download"></i>
                                <i class="fa fa-stack-1x fa fa-list-alt"></i>
                            </span>
                        </div>
                        <div class="admin-label">Generate Source Tracking Report</div>
                    </li>
                    <li class="menu-item" data-automation-id="top-nav-bar-generate-processing-report"
                        (click)="reefReviewGenerateProcessingReport()"
                        [title]="'Generate Processing Report (.xlsx) for download from the Work Basket'">
                        <div class="admin-icon">
                            <span class="fa-stack">
                                <i class="fa fa-download"></i>
                                <i class="fa fa-stack-1x fa fa-list-alt"></i>
                            </span>
                        </div>
                        <div class="admin-label">Generate Processing Report</div>
                    </li>
                </ul>
            </li>
        </div>
    </div>
    <div class="right-menu" *ngIf="!isRightMenuHidden">
        <li class="dropdown pulldown-section on-hover"
            *ngIf="hasActiveUserSessionsPermission || hasJobHistoryPermission || hasJobManagementPermission || hasOCRUsageDownloadReportPermission || hasMonitoringPermission"
            dropdown>
            <div dropdownToggle role="button" class="status-actions"
                data-automation-id="top-nav-bar-status-dropdown-button">
                <i class="fa fa-heartbeat fa-icon sizing-icons"></i>
                <span class="heartbeat-icon" data-automation-id="top-nav-bar-status-label">Status</span>
                <i class="fa fa-caret-down admin-caret"></i>
            </div>
            <ul *dropdownMenu class="dropdown-menu">
                <li class="menu-item status-item" data-automation-id="top-nav-bar-job-mgmt-button"
                    *ngIf="hasJobManagementPermission" (click)="openStatusManagement('Job Management')">
                    <div class="admin-icon">
                        <i class="fa fa-tasks"></i>
                    </div>
                    <div class="admin-label">Job Management ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-job-history-button"
                    *ngIf="hasJobHistoryPermission" (click)="openStatusManagement('Job and Error History')">
                    <div class="admin-icon">
                        <i class="fa fa-history"></i>
                    </div>
                    <div class="admin-label">Job and Error History ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-sessions-button"
                    *ngIf="hasActiveUserSessionsPermission" (click)="openStatusManagement('Active User Sessions')">
                    <div class="admin-icon">
                        <span class="fa-stack">
                            <i class="fa fa-user"></i>
                            <i class="fa fa-stack-1x fa-clock-o"></i>
                        </span>
                    </div>
                    <div class="admin-label">Active User Sessions ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-project-access-history-button"
                    *ngIf="hasProjectAccessHistoryPermission" (click)="openStatusManagement('Project Access History')">
                    <div class="admin-icon">
                        <span class="fa-stack">
                            <i class="fa fa-book"></i>
                            <i class="fa fa-stack-1x fa fa-history"></i>
                        </span>
                    </div>
                    <div class="admin-label">Project Access History ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-system-audit-log-button"
                    *ngIf="hasSystemAuditLogPermission" (click)="openStatusManagement('System Audit Log')">
                    <div class="admin-icon">
                        <span class="fa-stack">
                            <i class="fa fa-gear"></i>
                            <i class="fa fa-stack-1x fa-history"></i>
                        </span>
                    </div>
                    <div class="admin-label">System Audit Log ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-monitoring-button"
                    *ngIf="hasMonitoringPermission" (click)="openStatusManagement('Monitoring')">
                    <div class="admin-icon">
                        <span class="fa-stack">
                            <i class="fa fa-dashboard"></i>
                        </span>
                    </div>
                    <div class="admin-label">Monitoring ...</div>
                    <div class="new-tab-icon" title="Opens in a new tab or window.">
                        <i class="fa fa-window-restore"></i>
                    </div>
                </li>
                <li class="divider"></li>
                <li class="menu-item status-item" data-automation-id="top-nav-bar-ocr-usage-report-button"
                    *ngIf="hasOCRUsageDownloadReportPermission" (click)="openStatusManagement('OCR Usage Report')">
                    <div class="admin-icon">
                        <span class="fa-stack">
                            <i class="fa fa-download"></i>
                            <i class="fa fa-stack-1x fa fa-list-alt"></i>
                        </span>
                    </div>
                    <div class="admin-label">OCR Usage Report ...</div>
                </li>
            </ul>
        </li>
        <li class="dropdown pulldown-section on-hover" dropdown
            *ngIf="isSystemUserWithAdminRights() || (projectName && settingsPermissions)">
            <div dropdownToggle role="button" class="admin-actions" data-automation-id="top-nav-bar-settings-button">
                <i class="fa fa-gears fa-icon sizing-icons"></i>
                <span class="user-icon" data-automation-id="top-nav-bar-current-username-label">Settings</span>
                <i class="fa fa-caret-down admin-caret"></i>
            </div>
            <ul *dropdownMenu class="dropdown-menu">
                <li (click)="openSystemSettings()" class="menu-item"
                    data-automation-id="top-nav-bar-settings-system-settings-button"
                    *ngIf="isSystemUserWithAdminRights()">
                    <div class="admin-icon">
                        <i class="fa fa-gears sizing-icons sizing-purple"></i>
                    </div>
                    <div class="admin-label">System Settings ...</div>
                </li>
                <li (click)="openSettings('organization')" class="menu-item"
                    data-automation-id="top-nav-bar-settings-organzation-settings-button"
                    *ngIf="projectName && settingsPermissions">
                    <div class="admin-icon">
                        <i class="fa fa-gears sizing-icons sizing-tan"></i>
                    </div>
                    <div class="admin-label">Organization Settings ...</div>
                </li>
                <li (click)="openSettings('project')" class="menu-item" *ngIf="projectName && settingsPermissions"
                    data-automation-id="top-nav-bar-settings-project-settings-button">
                    <div class="admin-icon">
                        <i class="fa fa-gears sizing-icons sizing-blue"></i>
                    </div>
                    <div class="admin-label">Project Settings ...</div>
                </li>
            </ul>
        </li>
        <li class="dropdown pulldown-section on-hover" dropdown>
            <div dropdownToggle role="button" class="admin-actions"
                data-automation-id="top-nav-bar-current-user-dropdown-button">
                <i class="fa fa-user fa-icon sizing-icons"></i>
                <span class="user-icon" data-automation-id="top-nav-bar-current-username-label">{{username}}</span>
                <i class="fa fa-caret-down admin-caret"></i>
            </div>
            <ul *dropdownMenu class="dropdown-menu">
                <li (click)="logOut()" class="menu-item" data-automation-id="top-nav-bar-logout-button">
                    <div class="admin-icon">
                        <i class="fa fa-sign-out"></i>
                    </div>
                    <div class="admin-label">Log out</div>
                </li>
                <li (click)="logOutOnAllDevices()" class="menu-item" *ngIf="!commonService.isTPAuthEnabledSystem"
                    title="You will be logged out on all devices and your &quot;Remember Me&quot; password will be cleared."
                    data-automation-id="top-nav-bar-logout-all-devices-button">
                    <div class="admin-icon">
                        <i class="fa fa-sign-out"></i>
                    </div>
                    <div class="admin-label">Log out on All Devices</div>
                </li>
            </ul>
        </li>
        <li class="dropdown pulldown-section on-hover" dropdown>
            <div dropdownToggle role="button" class="admin-actions"
                data-automation-id="top-nav-bar-help-dropdown-button">
                <i class="fa fa-question fa-icon sizing-icons"></i>
                <span class="user-icon" data-automation-id="top-nav-bar-help-label">Help</span>
                <i class="fa fa-caret-down admin-caret"></i>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li (click)="openHelp()" class="menu-item" data-automation-id="top-nav-bar-help-button">
                    <div class="admin-icon">
                        <i class="fa fa-question"></i>
                    </div>
                    <div class="admin-label">Reef ECA Help ...</div>
                </li>
                <li (click)="openMetadataHelp()" class="menu-item" data-automation-id="top-nav-bar-metadata-button">
                    <div class="admin-icon">
                        <i class="fa fa-question"></i>
                    </div>
                    <div class="admin-label">Reef ECA Metadata ...</div>
                </li>
                <li class="dropdown-divider"></li>
                <li (click)="navigateToPrivacyPolicy()" class="menu-item"
                    data-automation-id="top-nav-bar-privacy-policy-button">
                    <div class="admin-icon">
                        <i class="fa fa-info"></i>
                    </div>
                    <div class="admin-label">Privacy Policy</div>
                    <div class="admin-icon external-link-icon">
                        <i class="fa fa-external-link" title="External link. Opens in a new tab or window."></i>
                    </div>
                </li>
                <li (click)="openEndUserLicenseAgreementModal()" class="menu-item"
                    data-automation-id="top-nav-bar-eula-button">
                    <div class="admin-icon">
                        <i class="fa fa-info"></i>
                    </div>
                    <div class="admin-label">End User License Agreement ...</div>
                </li>
                <li class="dropdown-divider"></li>
                <li (click)="openAboutModal()" class="menu-item" data-automation-id="top-nav-bar-about-button">
                    <div class="admin-icon">
                        <i class="fa fa-info-circle"></i>
                    </div>
                    <div class="admin-label">About Reef ECA ...</div>
                </li>
            </ul>
        </li>
    </div>
    <ng-template #contentTemplate>
        <div style="width:365px">
            <span>Copyright © 2007-2026. Digital Reef, Inc. All Rights Reserved</span>
            <p></p>
            <span>Portions of this program suite are licensed under United States Patent No. 6,918,082.</span>
            <p></p>
            <span>{{"R5.5.4.1-d5135269502926d5-39442464f492ed4c"}}</span><br />
            <span>{{"2026-09-03 16:11"}}</span>
        </div>
    </ng-template>
    <a #openForReviewLink hidden target="_blank"></a>
</div>